import { emptySources } from './empty';
import type { Sources } from './types';

/* The one place the console decides where its data comes from.
 *
 * Today: nothing. The authed app runs on `emptySources`, and the preview
 * harness installs a fixture pair for the length of its own route. When the
 * control plane grows read routes this file gains a live pair and nothing above
 * it changes. */

let current: Sources = emptySources;
const listeners = new Set<() => void>();

export function getSources(): Sources {
  return current;
}

/** Install a source pair. Returns a restore function, so the preview harness
 *  cannot leak its fixtures into the authed routes when the operator navigates
 *  out of it — the harness restores on unmount. */
export function setSources(next: Sources): () => void {
  const previous = current;
  current = next;
  listeners.forEach((l) => l());
  return () => {
    current = previous;
    listeners.forEach((l) => l());
  };
}

export function onSourcesChanged(l: () => void): () => void {
  listeners.add(l);
  return () => listeners.delete(l);
}

export { emptySources };
export type { LiveSource, QuerySource, Sources, LedgerQuery, AnalyticsQuery } from './types';
